import { useCallback } from "react";
import { useMutation } from "@apollo/client";
import { Mutation, MutationUpsertVehicleArgs, VehicleInput } from "../generated/nest-graphql";
import { UPSERT_VEHICLE } from "../graphql/mutations/upsertVehicle";

/** Saves a vehicle record through the same upsert the job tab's vehicle form uses. Rejects on failure. */
export const useUpdateVehicle = () => {
  const [upsertVehicle, { loading }] = useMutation<Mutation, MutationUpsertVehicleArgs>(UPSERT_VEHICLE);
  const save = useCallback(
    async (vehicleInputData: VehicleInput) => {
      await upsertVehicle({ variables: { vehicleInputData } });
    },
    [upsertVehicle]
  );
  return { save, saving: loading };
};
